import { formatResultValue } from "../utils/numericUtils";

const Row = ({ title, value }) => (
    <div className="result-panel">
        <div className="result-title">{title}</div>
        <div className="result-value">{value}</div>
    </div>
);

export default function AdvancedResults({ result }) {
    if (!result || Object.keys(result).length === 0) return null;

    return (
        <>
            <div className="step-header">Step 1</div>
            <Row
                title="Non-Paid Emissions (tCO₂/t goods)"
                value={formatResultValue(result.non_paid_emissions, { isDouble: true })}
            />

            <div className="step-header">Step 2</div>
            <Row
                title="Non-Paid CBAM Cost (€/t goods)"
                value={formatResultValue(result.non_paid_cbam_cost, { isPriceFloat: true })}
            />

            <div className="step-header">Step 3</div>
            <Row
                title="Non-Paid # of Certifications (tCO₂)"
                value={formatResultValue(result.certificates, { isAmount: true })}
            />

            <div className="step-header">Step 4</div>
            <Row
                title="Non-Paid CBAM Payment (€)"
                value={formatResultValue(result.non_paid_cbam_payment, { isPrice: true })}
            />

            <div className="step-header">Step 5</div>
            <Row
                title="Non-Paid Margin Ratio (%)"
                value={formatResultValue(result.non_paid_margin_ratio ? result.non_paid_margin_ratio * 100 : null, { isPercentage: true })}
            />
            <div className="divider padding_double"></div>
        </>
    );
}
